var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',{staticClass:"copy"},[_vm._v("© PHILIP MORRIS PRODUCTS SA")]),_c('a',{attrs:{"href":"https://pmiprivacy.com/th/traders","target":"_blank"}},[_vm._v(" PRIVACY NOTICE ")])])
}]

export { render, staticRenderFns }